exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".vp-inline-label{line-height:35px;white-space:nowrap;float:left}.vp-error .vp-inline-label{color:#333}.required-asterisk{color:#ff553d;font-weight:100;font-size:12px}.vp-label-indent{padding-left:.5rem;padding-right:.25rem}.vp-field.v2{width:100%}.vp-field .vp-error-message{display:inline-block;padding-top:4px}", ""]);

// exports
